import { SearchFilter } from '../../../types';
import { hasInvalidValues } from '../../text-field-accordion-filter/utils';

export function useTextFieldFilterError(
  filter: SearchFilter,
  values?: string[]
) {
  if (!filter.metadata?.validation?.type) return false;
  return hasInvalidValues(values ?? [], filter.metadata?.validation?.type);
}
